import type { ComponentProps } from 'react'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import { useIntl } from 'react-intl'
import type { OfferTilePriceBlockVariation } from 'lib/offer/offerTilePriceBlockExperiment'
import { formatOfferTilePriceCaption, type OfferTilePriceCaptionOptions } from 'lib/offer/formatOfferTilePriceCaption'

interface Props extends ComponentProps<typeof PriceRowPriceCaption>, OfferTilePriceCaptionOptions {
  priceBlockExperimentVariation?: OfferTilePriceBlockVariation
  isPricePerNight?: boolean
}

/** Shares duration/unit formatting, while control keeps its original caption. */
export default function OfferTilePriceBlockCaption({
  priceBlockExperimentVariation, duration, durationLabel, saleUnit, unitCount, checkIn, checkOut, isPricePerNight, children, ...props
}: Props) {
  const intl = useIntl()
  if (!priceBlockExperimentVariation) return <PriceRowPriceCaption {...props}>{children}</PriceRowPriceCaption>

  const caption = formatOfferTilePriceCaption(intl, { duration, durationLabel, saleUnit, unitCount, checkIn, checkOut }) ?? children
  // Moving /night must not turn a nightly amount into an apparent full-stay total.
  const displayCaption = isPricePerNight ? intl.formatMessage(
    {
      id: '-YdUOkt6D3W1W21DQZk_',
      defaultMessage: '{caption} (per night)',
    },
    { caption },
  ) : caption
  return <PriceRowPriceCaption {...props}>{displayCaption}</PriceRowPriceCaption>
}
